// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"626":"b6323009d4472833","2888":"c7a681454e24d512","7966":"b6323009d4472833"}[chunkId] + ".css";
};